import { Link } from 'react-router-dom';
import { Activity, Boxes, Package, Server, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function AdminHeader({ activeTab, onSelectTab }: {
  activeTab: string;
  onSelectTab?: (tabId: string) => void;
}) {
  const { t } = useTranslation();
  const tabs = [
    { id: 'host-agents', name: t('admin.vpcs'), icon: Server, href: '/admin' },
    { id: 'packages', name: t('admin.packages'), icon: Package, href: '/admin?tab=packages' },
    { id: 'custom-products', name: 'Custom Products', icon: Boxes, href: '/admin?tab=custom-products' },
    { id: 'custom-instances', name: 'Custom Instances', icon: Server, href: '/admin/custom-instances' },
    { id: 'diagnostics', name: 'Diagnostics', icon: Activity, href: '/admin?tab=diagnostics' },
    { id: 'commands', name: t('admin.commands'), icon: Zap, href: '/admin?tab=commands' },
  ];

  return <>
    <div className="mb-8">
      <h1 className="text-2xl font-bold text-gray-100">{t('admin.title')}</h1>
      <p className="text-gray-500 text-sm mt-1">Agents, packages, real capacity and lifecycle operations</p>
    </div>
    <nav aria-label="Admin sections" className="flex gap-2 mb-8 border-b border-dark-700 pb-px overflow-x-auto">
      {tabs.map(tab => <Link
        key={tab.id}
        to={tab.href}
        className={activeTab === tab.id ? 'tab-active' : 'tab'}
        aria-current={activeTab === tab.id ? 'page' : undefined}
        onClick={event => {
          if (onSelectTab && tab.id !== 'custom-instances' && event.button === 0
            && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            onSelectTab(tab.id);
          }
        }}
      ><tab.icon className="w-4 h-4" />{tab.name}</Link>)}
    </nav>
  </>;
}
